/**
 * Başlık geometrisi — alt çubuğunkiyle (floatingDockLayout) aynı desende.
 *
 * Başlık içeriğin üstünde YÜZDÜĞÜNDE, kaydırılan içerik onun altından geçer ve
 * o yüzden aynı yüksekliği tepede boşluk olarak geri alması gerekir. Sayıyı iki
 * yerde tutmak, boşluğun zamanla başlıktan ayrışması demek; tek yerden türüyor.
 */
export const screenHeaderMetrics = {
  /** ScreenHeader'ın içerik satırı — geri kontrolü tam buraya oturur. */
  contentHeight: 56,
} as const;

/** Güvenli alan ekranda eklenir; cihazdan cihaza değişir. */
export const screenHeaderContentInset = (safeTop: number) =>
  safeTop + screenHeaderMetrics.contentHeight;
